import Graylog from 'components/domain/analytics/Graylog/Graylog';
import AnalyticsEvent from 'utils/constants/analytics/analyticsEvent';
import { useActiveMember } from 'hooks';
import { useCallback, useMemo } from 'react';

function useManagementAnalytics() {
  const member = useActiveMember();

  const recordClickExportEmployees = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_EXPORT_EMPLOYEES,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickExportProjects = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_EXPORT_PROJECTS,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickExportCostCodes = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_EXPORT_COST_CODES,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickExportEquipment = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_EXPORT_EQUIPMENT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickPrintEmployees = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_PRINT_EMPLOYEES,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickPrintProjects = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_PRINT_PROJECTS,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickPrintCostCodes = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_PRINT_COST_CODES,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  const recordClickPrintEquipment = useCallback(() => {
    Graylog({
      shortMsg: AnalyticsEvent.managementLists.MANAGEMENT_LISTS_PRINT_EQUIPMENT,
      logObject: {
        _member_id: member.id,
        _member_position_id: member.positionId,
      },
    });
  }, [member.id, member.positionId]);

  return useMemo(
    () => ({
      recordClickExportEmployees,
      recordClickExportProjects,
      recordClickExportCostCodes,
      recordClickExportEquipment,
      recordClickPrintEmployees,
      recordClickPrintProjects,
      recordClickPrintCostCodes,
      recordClickPrintEquipment,
    }),
    [
      recordClickExportEmployees,
      recordClickExportProjects,
      recordClickExportCostCodes,
      recordClickExportEquipment,
      recordClickPrintEmployees,
      recordClickPrintProjects,
      recordClickPrintCostCodes,
      recordClickPrintEquipment,
    ]
  );
}

export default useManagementAnalytics;
